import "./gender.scss";
import "./genderResponsive.sass";
import {Link, NavLink, useHistory, useLocation} from "react-router-dom";
import { Hero } from "../../container/index";
import React, { useState } from "react";
import { News, Helm } from "../../components/index";
import { useEffect } from "react";
import { request } from "../../api/request";
import TomchiLogo from '../../assets/icons/TOMCHILOGO.png'
import { useDispatch } from "react-redux";
import { set_data } from "../../redux/action";
import { useSelector } from "react-redux";
import parser from "html-react-parser";
import QRcode from '../../assets/qrCode.png'
const Gender = () => {

    const dispatch = useDispatch();

    const event = useSelector((state) => state.data.data);
    const lang = useSelector((state) => state.data.lang);
    const news = useSelector(state => state.data.news)
    const [categories, setCategories] = useState([])

    const [active, setActive] = useState(0)

    const history = useHistory();
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        request
            .get(`/content/all/event?sort=DESC&sortby=id&lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => dispatch(set_data(res.data)))
            .catch((err) => console.log(err));

        request
            .get(`/segment/all/event_category?lang=${lang === null ? "uz" : lang}`, {
                headers: {
                    "api-token": "p12378",
                },
            })

            .then((res) => setCategories(res.data))
            .catch((err) => console.log(err));
    }, [lang]);
    return (
        <div className="events-page">
            {/*<Helm id={"37"}/>*/}

            <div className="hero-page">
                <Hero
                    id={"663"}
                    nameOne={
                        lang === "uz"
                            ? "Bosh sahifa"
                            : lang === "ru"
                                ? "Домой"
                                : lang === "en"
                                    ? "Home page"
                                    : ""
                    }
                    nameTwo={
                        lang === "uz"
                            ? "Gender konsepsiyasi"
                            : lang === "ru"
                                ? "Открытые данные"
                                : lang === "en"
                                    ? "Open data"
                                    : ""
                    }
                    linkOne={"/"}
                    linkTwo={"/gender-konsepsiya"}
                />
            </div>

            <div className="inner-pages container">
                <div className="col-one">
                    <div className="heading">
                        <h1 className="news-holder">Kategoriya</h1>
                    </div>
                    <div className="events-category">
                        <button
                            onClick={() => history.push('/gender-konsepsiya')}
                            className={currentPath === '/gender-konsepsiya' ? 'active' : ''}
                        >
                            Gender konsepsiyasi
                        </button>
                        <button
                            onClick={() => history.push('/gender-material')}
                            className={currentPath === '/gender-material' ? 'active' : ''}
                        >
                            Rasmiy taqdimot materiallari
                        </button>
                        <button
                            onClick={() => history.push('/gender-hikoya')}
                            className={
                                currentPath === '/gender-hikoya' ||
                                currentPath === '/gender-hikoya-1' ||
                                currentPath === '/gender-hikoya-2'
                                    ? 'active'
                                    : ''
                            }
                        >
                            Loyiha hikoyalari
                        </button>
                    </div>
                    <div className="tomchi">
                        <img src={QRcode} alt=""/>
                    </div>
                    <div className="tomchi-links">
                        <img src={TomchiLogo} alt=""/>
                        <h3 style={{
                            fontSize: '13px'
                        }} className='tomchi-title'>QR code skanerlang va Tomchi mobil ilovasini yuklab oling.</h3>
                    </div>
                </div>

                <div className="col-two">
                    <div className="heading">
                        <h1 className="news-holder">Suv xo'jaligida gender konsepsiyasi</h1>
                    </div>
                    <h2 style={{textAlign: "center", marginBottom: "10px"}}>"Daryo bir tomchidan boshlanadi: suv
                        sohasida teng imkoniyatlar sari yo‘lim"</h2>

                    <div className="two-column">
                        <div className="image-side">
                            <img
                                src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot7.webp"
                                alt="AS"
                            />
                        </div>
                        <div className="text-side">
                            <p>
                                Mening ismim — Xasanova Adolat. Men Xorazm viloyatining Kushko’pir suv ta'minoti
                                xizmatida bosh gidrometr bo‘lib ishlayman. Suv resurslarini boshqarish — bu shunchaki
                                ish emas, bu mening hayotimning bir qismidir. Bugun men sizlar bilan nafaqat men uchun,
                                balki bizning sohamizda ishlayotgan barcha ayollar uchun muhim bo‘lgan bir hikoyamni
                                bo‘lishmoqchiman.
                            </p>
                            <p>
                                Men suv sohasiga ilk bor kelganimda bu yerda ayollar juda kam ekanligiga e’tibor
                                berdim: Bu soha hali ham “erkaklar sohası” deb hisoblanadi. Bunga raqamlar ham
                                tasdiq beradi. Hozirda tizimda faqatgina taxminan 7% ayollar ishlaydi. Rahbarlik
                                lavozimlarida esa yanada kam — bor-yo‘g‘i 3%. O‘zingiz tasavvur qiling: butun
                                mamlakat bo‘yicha suv sohasida faqat 76 nafar ayol rahbar bor, xolos.
                            </p>
                            <p>
                                Bunday vaziyat faqat bizga xos emas. BMTning 2022 yildagi ma’lumotlariga ko‘ra,
                                dunyo bo‘ylab suv sohasidagi haq to‘lanadigan ish joylarining kamroq — 17% dan
                                kamrog‘ini ayollar egallaydi.
                            </p>
                        </div>
                    </div>

                    <div className="two-column">
                        <div className="text-side">
                            <p>
                                Yosh mutaxassislar masalasiga kelsak, bu yerda ham hammasi oddiy emas.
                                Faqat 8% yosh xodimlar — qizlar. Ya’ni yangi ishga qabul qilinganlar
                                orasida atigi 363 nafar ayol bor. Karyerani boshlash qiyin, imkoniyatlar
                                kam, bu esa o‘sishga, rivojlanishga, yuqoriroq lavozimlarga ko‘tarilishga
                                to‘sqinlik qiladi. Ko‘p hollarda ayollar kichik lavozimlarda qolib ketishadi,
                                garchi ular oldinga harakatlanish uchun barcha salohiyatga ega bo‘lsalar ham.
                            </p>
                        </div>
                        <div className="image-side">
                            <img
                                src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot8.webp"
                                alt="AS"
                            />
                        </div>
                    </div>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        2022 yilda men birinchi marta o‘zgarishlar mumkinligini his qildim. O‘sha paytda men
                        Suv resurslarini boshqarish milliy loyihasi doirasida tashkil etilgan suv sohasidagi
                        birinchi gender tadqiqoti taqdimotida ishtirok etdim. Bu burilish nuqtasi bo‘ldi.
                        Biz faqat muammolar haqida gaplashmagandik — bizni eshitishayotganini his qildik.
                        Bizning ovozimiz ahamiyatga ega ekanini angladik.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        O‘shandan beri hayotimda ko‘p narsa o‘zgardi. Men loyiha tomonidan tashkil etilgan seminarlar
                        va onlayn kurslarda faol ishtirok eta boshladim. 2022 yil mart oyida ayollarning iqtisodiy
                        huquq va imkoniyatlarini kengaytirish bo‘yicha o‘quv kursini tamomladim, keyinchalik esa
                        Xorazm viloyatida gender bo‘yicha trenerga aylandim. Hozirda men suv resurslarini boshqarish
                        sohasidagi ayol mutaxassislar hamda ayol fermerlar uchun treninglar o‘tkazmoqdaman. Loyiha
                        jamoasi bilan birga yoki mustaqil ravishda
                        bilimlarimni ulashaman, ilhomlantiraman, boshqa ayollarning hikoyalarini tinglayman.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Ayniqsa, menga Navoiy, Buxoro viloyatlarida va Farg‘ona vodiyidagi safarli seminarlar esda
                        qolarli bo‘ldi. Bu shunchaki o‘qituv emas edi — bu haqiqiy o‘sish va ilhom sayohatlari edi.
                        Biz o‘rgandik, muhokama qildik, bahslashdik va bir-birimizni qo‘lladik.
                    </p>

                    <img src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot10.webp" alt="AS"
                         style={{width: "100%"}}/>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Va nihoyat, 2025 yilda biz uzoq kutilgan voqeaga guvoh bo‘ldik — 22-aprel
                        kuni O‘zbekistonda 2030 yilgacha mo‘ljallangan Suv xo‘jaligida gender konsepsiyasi rasman
                        tasdiqlandi. Biz Xorazmda,
                        ayol mutaxassislar orasida, buni katta ruhiy ko‘tarinkilik bilan qabul qildik. Biz his qildik:
                        endi bizda shunchaki umid emas, balki aniq harakatlar rejasi bor.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Menga ishonch baxsh etadigan jihati shuki — Gender konsepsiyasida aniq yozilgan:
                        rahbarlik lavozimlarini egallay oladigan ayollar sonini oshirish uchun kadrlar
                        zaxirasini yaratish zarur. Shuningdek, ayollarni yetakchilikka tayyorlash uchun maxsus
                        treninglar o‘tkazilishi kerakligi ham ko‘rsatilgan.
                        Trener sifatida bu men uchun juda muhim. Chunki chiroyli so‘zlar ortida bu safar haqiqiy amaliy
                        ishlar turibdi. Biz buni allaqachon ko‘rib turibmiz.
                    </p>

                    <img src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot11.webp" alt="AS"
                         style={{width: "100%"}}/>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Eng ko‘p ilhom bergan narsa — bu Konsepsiya bilan birga qabul qilingan Harakatlar rejasi bo‘ldi.
                        Bu shunchaki rasmiy hujjat emas — bu bosqichma-bosqich yo‘riqnoma. Eng asosiysi — bizning
                        oramizda, ayollar ham, erkaklar ham, uni amalga oshirishni chin
                        dildan xohlayotganlar bor. Biz kimdir kelib nimanidir qiladi deb kutmayapmiz. Biz o‘zimiz ham bu
                        o‘zgarishlarning bir qismiga aylanishga tayyormiz.
                    </p>

                    <p style={{textIndent: "20px", textAlign: "justify", marginBottom: "12px"}}>
                        Ishonamanki, agar biz birgalikda ishlasak — bir-birimizni qo‘llab-quvvatlasak, bilimlarimizni
                        ulashsak,
                        yangi mutaxassislar uchun yo‘l ochsak — vaziyat albatta o‘zgaradi. Biz allaqachon shu yo‘lga
                        chiqqanmiz. Va har birimiz, har bir hikoya, har bir qadam — muhimdir.
                    </p>

                    <img src="https://wsrc-assets.wsrc.uz/uploads/2025/iyun/screenshot12.webp" alt="AS"
                         style={{width: "100%"}}/>

                </div>

                <div className="col-thr">
                    <h1 className="news-holder">
                        {lang === "uz"
                            ? "So’ngi yangiliklar"
                            : lang === "ru"
                                ? "последние новости"
                                : lang === "en"
                                    ? "Last news"
                                    : ""}
                    </h1>
                    {news && news.status === 1 ? (
                        news.data &&
                        news.data.map((el, index) => (
                            <News
                                date={el.created_on}
                                key={index}
                                title={el.title}
                                id={el.id}
                            />
                        ))
                    ) : (
                        <h1>Loading ...</h1>
                    )}
                </div>
            </div>

            <div className="margin"></div>
        </div>
    );
};

export default Gender;
